// A porção da venda por peso com preço próprio vence a conta peso × preço do kg/litro (e a promoção por kg), no link e
// no PDV (Pedro, 04/11/2026, T-0056: no PDV a porção saía pela conta; Mello Maison de Parfum, decant de 2 ml a R$ 25,90).
// O peso casa com a porção com tolerância de 0,0005 kg (meio grama/ml), a mesma do link desde sempre. Regra única para o
// servidor (link, PDV público, PDV do painel e edição) e as telas.
export interface PorcaoDePeso {
  kg: number;
  price: number | null;
}

/** As porções gravadas (products.portions), aceitando o formato antigo (número solto, sem preço). */
export function porcoesDoProduto(portions: unknown): PorcaoDePeso[] {
  if (!Array.isArray(portions)) return [];
  return portions
    .map((v) =>
      typeof v === "number"
        ? { kg: v, price: null }
        : { kg: Number((v as { kg?: unknown })?.kg), price: (v as { price?: unknown })?.price != null ? Number((v as { price?: unknown }).price) : null },
    )
    .filter((o) => Number.isFinite(o.kg));
}

/** A porção desse peso, se houver. */
export function porcaoDoPeso(portions: unknown, weightKg: number): PorcaoDePeso | null {
  return porcoesDoProduto(portions).find((o) => Math.abs(o.kg - weightKg) < 0.0005) ?? null;
}

/** O preço da porção desse peso, quando ela tem preço preenchido (maior que 0); senão null (vale peso × preço do kg). */
export function precoDaPorcao(portions: unknown, weightKg: number): number | null {
  const p = porcaoDoPeso(portions, weightKg);
  return p && p.price != null && Number.isFinite(p.price) && p.price > 0 ? Math.round(p.price * 100) / 100 : null;
}
